import { useContext } from 'react'

import CampaignProvider, { CampaignContext } from './Provider'

export { CampaignProvider, CampaignContext }
export type { ICampaignContextProps } from './Provider'

export const useCampaignContext = () => useContext(CampaignContext)
